import { useEffect, useState } from 'react';

import useCurrentUser from '~/hooks/useCurrentUser';

import { readLensVisits, subscribeLensVisits } from './lensVisits';

export function useLensVisits() {
  const { user } = useCurrentUser();
  const email = user?.email;
  const [snapshot, setSnapshot] = useState(() => ({ email, visits: readLensVisits(email) }));
  const visits = snapshot.email === email ? snapshot.visits : readLensVisits(email);
  useEffect(() => {
    const sync = () => setSnapshot({ email, visits: readLensVisits(email) });
    sync();
    return subscribeLensVisits(sync, email);
  }, [email]);
  return visits;
}
